import { rgba } from 'polished';
import { css } from '@emotion/core';
import theme from '../themes/default';

const opacity = ({ color = 'black', alpha = 'alpha76' } = {}) =>
  rgba(theme.color[color], theme.opacity[alpha]);

const colorPicker = ({ seed, choices }) => {
  const safeSeed = seed || '';
  let sum = 0;
  for (let i = 0; i < safeSeed.length; i += 1) {
    sum += safeSeed.charCodeAt(i);
  }
  return choices[sum % choices.length];
};

// workaround for https://github.com/emotion-js/emotion/issues/1333
const small = ({ weight = 'regular' } = {}) => css`
  font-size: ${theme.font.size.small};
  font-weight: ${String(theme.font.weight[weight])};
  line-height: ${theme.font.lineHeight.small};
`;

// workaround for https://github.com/emotion-js/emotion/issues/1333
const copy = ({ weight = 'regular', lineHeight = 'copy' } = {}) => css`
  font-size: ${theme.font.size.copy};
  font-weight: ${String(theme.font.weight[weight])};
  line-height: ${theme.font.lineHeight[lineHeight]};
`;

// workaround for https://github.com/emotion-js/emotion/issues/1333
const headline = ({ weight = 'bold' } = {}) => css`
  font-size: ${theme.font.size.headline};
  font-weight: ${String(theme.font.weight[weight])};
  line-height: ${theme.font.lineHeight.headline};
`;

// workaround for https://github.com/emotion-js/emotion/issues/1333
const large = ({ weight = 'bold' } = {}) => css`
  font-size: ${theme.font.size.large};
  font-weight: ${String(theme.font.weight[weight])};
  line-height: ${theme.font.lineHeight.large};
`;

// workaround for https://github.com/emotion-js/emotion/issues/1333
const display = ({ weight = 'bold' } = {}) => css`
  font-size: ${theme.font.size.large};
  font-weight: ${String(theme.font.weight[weight])};
`;

const truncate = () => css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const reset = () => css`
  * {
    box-sizing: border-box;
  }

  body {
    font-family: ${theme.font.family.system};
    font-size: 1rem;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
`;

const flexContainer = ({
  direction = 'row',
  inline = false,
  justifyContent = 'center',
  alignItems = 'center',
} = {}) => css`
  display: ${inline ? 'inline-flex' : 'flex'};
  flex-direction: ${direction};
  justify-content: ${justifyContent};
  align-items: ${alignItems};
`;

const square = ({ size = '20px' } = {}) => css`
  height: ${size};
  width: ${size};
`;

const visuallyHidden = () => css`
  position: absolute !important;

  width: 1px;
  height: 1px;
  margin: -1px;
  border: 0;
  padding: 0;

  white-space: nowrap;

  clip-path: inset(100%);
  clip: rect(0 0 0 0);
  overflow: hidden;
`;

export default {
  color: {
    opacity,
    picker: colorPicker,
  },
  typography: {
    small,
    copy,
    large,
    headline,
    display,
    truncate,
  },
  flex: {
    container: flexContainer,
  },
  base: {
    reset,
    square,
  },
  visuallyHidden,
};
